import { apiTypeHelper } from '@/base/network'

export const LIST_COURSES_PACKAGES = apiTypeHelper('LIST_COURSES_PACKAGES')
export const LIST_MEMBERSHIP_PACKAGES = apiTypeHelper('LIST_MEMBERSHIP_PACKAGES')
export const CREATE_COURSES_PACKAGE = apiTypeHelper('CREATE_COURSES_PACKAGE')
export const CREATE_MEMBERSHIP_PACKAGE = apiTypeHelper('CREATE_MEMBERSHIP_PACKAGE')
export const UPDATE_COURSES_PACKAGE = apiTypeHelper('UPDATE_COURSES_PACKAGE')
export const UPDATE_MEMBERSHIP_PACKAGE = apiTypeHelper('UPDATE_MEMBERSHIP_PACKAGE')
export const DELETE_COURSES_PACKAGE = apiTypeHelper('DELETE_COURSES_PACKAGE')
export const DELETE_MEMBERSHIP_PACKAGE = apiTypeHelper('DELETE_MEMBERSHIP_PACKAGE')